import Vue from 'vue'
// import axios from 'axios'
import VueRouter from 'vue-router'
import MoveTo from 'moveTo'
import Home from '../vue/parts/Home.vue'
import Machinery from '../vue/parts/Machinery.vue'
import Motorcycle from '../vue/parts/Motorcycle.vue'
import NewEnergyVehicleParts from '../vue/parts/NewEnergyVehicleParts.vue'
import '../vue/filters'

export default {
  init() {
    const routes = [
      { path: '/', component: Home },
      { path: '/machinery', component: Machinery },
      { path: '/motorcycle', component: Motorcycle },
      { path: '/new-energy-vehicle-parts', component: NewEnergyVehicleParts },
    ]

    const router = new VueRouter({
      // mode: 'history',
      routes,
    })

    Vue.use(VueRouter)

    new Vue({
      el: '.product-parts-app',
      data: {
        loading: false,
      },

      router,

      watch: {
        $route(to, from) {
          const moveTo = new MoveTo({
            tolerance: 170,
            duration: 800,
          })
          moveTo.move(document.querySelector('.product-parts-nav'))
        },
      },

      mounted() {},

      methods: {},
    })
  },
  finalize() {},
}
